import { useGetUsers } from './use-get-users';

export const useUsersTotalCount = (): number => {
  const filesQuery = useGetUsers();

  return filesQuery?.data?.pagination.totalItems ?? 0;
};
